import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { HeadingItem } from 'components/heading-item/heading-item';
import { ItemVerificationView } from 'enums';
import React, { FC } from 'react';
import { IconOptions } from 'types';
import './details-count-card.scss';

type Props = {
    id?: ItemVerificationView,
    icon: IconDefinition,
    title: string,
    value?: string | number | null,
    renderContent?: () => JSX.Element,
    rightHandIcon?: IconOptions;
    onClick: (id?: ItemVerificationView) => void
}

export const DetailsCountCard: FC<Props> = ({ id, icon, title, value, renderContent, rightHandIcon, onClick }) => {

    return (
        <div className={'details-count-card-material'} onClick={() => onClick(id)}>
            <HeadingItem
                leftHandIcon={{ icon: icon, color: '#0066A4', size: '1x' }}
                text={title}
                rightHandIcon={rightHandIcon}
            />
            {renderContent ?
                renderContent()
            :
                <div className={'details-count-card-count'}>{value != null ? value : 'N/A'}</div>
            }
        </div>
    )
};
